module.exports = __webpack_public_path__ + "img/satoryo.f66e5a95.jpg";